import { Layout as RaLayout, LayoutProps } from 'react-admin';

import { AppBar } from './AppBar/customMuiComponents';
import { Navbar } from './Navbar/Navbar.component';
export function Layout(props: LayoutProps) {
  return <RaLayout {...props} appBar={AppBar} menu={Navbar} />;
}
